/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconExclamationMark = createReactComponent("outline", "exclamation-mark", "IconExclamationMark", [["path", { "d": "M12 19v.01", "key": "svg-0" }], ["path", { "d": "M12 15v-10", "key": "svg-1" }]]);

export { IconExclamationMark as default };
//# sourceMappingURL=IconExclamationMark.mjs.map
